import { action, makeObservable, observable } from 'mobx'

import { ShopRootStore } from 'shop/stores/shopRoot.store'

import type { StripeElements, Stripe, StripeError } from '@stripe/stripe-js'

import SharedStore from 'shared/stores/shared.store'

export class PurchaseMethodsStore extends SharedStore<any> {
  storeName = 'PurchaseMethodsStore'
  root: ShopRootStore

  constructor(root: ShopRootStore) {
    super()
    this.root = root
    makeObservable(this)
  }

  @observable stripeClient: Stripe = null
  @observable stripePaymentElementError: StripeError = null
  @observable stripeAuthentificationLoading = false
  @observable stripeCardValid = false

  @observable paymethods: Record<string, never> = {}
  @observable fraudSessionIdentifier = null
  @observable shouldResetIntent = false
  @observable buyBtnDisabled = false
  @observable stripeElements: StripeElements = null
  @observable googleAvailability = {
    googlePay: false,
  }
  @observable appleAvailability = {
    applePay: false,
  }

  @action setStripeElements = (value: StripeElements) => (this.stripeElements = value)
  @action setStripeCardValidity = (isValid: boolean) => (this.stripeCardValid = isValid)
  @action updatePaymethodsData = (paymethods) => (this.paymethods = paymethods)
  @action setStripeClient = (value: Stripe) => (this.stripeClient = value)
  @action stripeAuthentificationLoadingToggle = (value) => (this.stripeAuthentificationLoading = value)
  @action setFraudSessionIdentifier = (value) => (this.fraudSessionIdentifier = value)
  @action setBuyBtnDisabling = (value: boolean) => (this.buyBtnDisabled = value)
  @action setGoogleAvailability = (resp) => (this.googleAvailability = resp)
  @action setAppleAvailability = (resp) => (this.appleAvailability = resp)
  @action setStripePaymentElementError = (error: StripeError) => (this.stripePaymentElementError = error)
}
